import React, { Component } from 'react';
import { Container, Row, UncontrolledAccordion, AccordionItem, AccordionHeader, UncontrolledTooltip } from 'reactstrap';
import { Puntaje } from './Puntaje';
function redondearHaciaArriba(valor: number): number {
    const decimal = valor % 1;
    return decimal >= 0.5 ? Math.ceil(valor) : Math.floor(valor);
}

export class DetalleScore extends Component {

    constructor(props) {
        super(props);
        this.state = { proveedor: props.proveedor };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.proveedor !== this.props.proveedor) {
            this.setState({ proveedor: this.props.proveedor });
        }
    }

    render() {

        if (!this.state.proveedor) {
            return null;
        }

        const factores = this.state.proveedor.FactoresQueSuman || [];
        const restan = this.state.proveedor.factoresQueRestan || [];

        return (
            <Container>
                <Row>

                    {/* ================= COLUMNA IZQUIERDA ================= */}
                    <div className="col-4">

                        <UncontrolledAccordion>

                            <AccordionItem
                                className={"factor factor-principal c" + (factores[4]?.color ?? 0)}
                                style={{ marginLeft: "18%", marginRight: "-18%" }}
                                id="factor4"
                            >
                                <AccordionHeader targetId="collapseS4">
                                    {factores[4]?.nombre ?? ""}
                                    <span>
                                        {factores[4]?.color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(factores[4]?.valor ?? 0)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor4" >
                                {factores[4]?.descripcion !== "" && factores[4]?.descripcion
                                    ? factores[4].descripcion
                                    : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>


                            <AccordionItem
                                className={"factor factor-principal c" + (factores[0]?.color ?? 0)}
                                id="factor0"
                            >
                                <AccordionHeader targetId="collapseS0">
                                    {factores[0]?.nombre ?? ""}
                                    <span>
                                        {factores[0]?.color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(factores[0]?.valor ?? 0)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor0" >
                                {factores[0]?.descripcion !== "" && factores[0]?.descripcion
                                    ? factores[0].descripcion
                                    : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                            <AccordionItem
                                className={"factor factor-principal c" + (factores[6]?.color ?? 0)}
                                style={{ marginLeft: "18%", marginRight: "-18%" }}
                                id="factor6"
                            >
                                <AccordionHeader targetId="collapseS6">
                                    {factores[6]?.nombre ?? ""}
                                    <span>
                                        {factores[6]?.color === 3
                                            ? <> - </>
                                            : redondearHaciaArriba(factores[6]?.valor ?? 0)}
                                    </span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor6">
                                {factores[6]?.descripcion !== "" && factores[6]?.descripcion
                                    ? factores[6].descripcion
                                    : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>

                        </UncontrolledAccordion>


                        <div className="extra">
                            Por consultas comunícate con el Centro de Atención a Proveedores<br />
                            <a href="mailto:performance@ypf.com">score@ypf.com</a>
                        </div>
                    </div>


                    {/* ================= COLUMNA CENTRAL ================= */}
                    <div className="col-4">
                        <Puntaje proveedor={this.state.proveedor} />
                    </div>

                    {/* ================= COLUMNA DERECHA ================= */}
                    <div className="col-4">

                        <div className="factores-restan-wrapper">
                            <UncontrolledAccordion style={{ textAlign: "center", marginTop: "30px" }}>
                                <AccordionItem className="factorr" id="resta1">
                                    <div>
                                        {restan[1]?.nombre ?? ""}<br />
                                        <img
                                            src={restan[1]?.valor > 0 ? "/check-x.png" : "/check-ok.png"}
                                            alt="estado"
                                            width="28px"
                                        />
                                        <br />

                                        <span>
                                            {restan[1]?.valor > 0 ? "NO CUMPLE" : "CUMPLE"}
                                        </span>
                                    </div>
                                </AccordionItem>

                                <UncontrolledTooltip placement="top" target="resta1">
                                    {restan[1]?.descripcion || "Sin información disponible"}
                                </UncontrolledTooltip>

                                <AccordionItem className="factorr" id="resta3">
                                    <div>
                                        {restan[3]?.nombre ?? ""}<br />
                                        <img
                                            src={restan[3]?.valor > 0 ? "/check-x.png" : "/check-ok.png"}
                                            alt="estado"
                                            width="28px"
                                        />
                                        <br />

                                        <span>
                                            {restan[3]?.valor > 0 ? "NO CUMPLE" : "CUMPLE"}
                                        </span>
                                    </div>
                                </AccordionItem>

                                <UncontrolledTooltip placement="top" target="resta3">
                                    {restan[3]?.descripcion || "Sin información disponible"}
                                </UncontrolledTooltip>

                                <AccordionItem className="factorr" id="resta2">
                                    <div>
                                        {restan[2]?.nombre ?? ""}<br />
                                        <img
                                            src={restan[2]?.ok ? "/check-x.png" : "/check-ok.png"}
                                            alt="estado"
                                            width="28px"
                                        />
                                        <br />

                                        <span>
                                            {restan[2]?.resta ?? ""}
                                        </span>
                                    </div>
                                </AccordionItem>

                                <UncontrolledTooltip placement="top" target="resta2">
                                    {restan[2]?.descripcion || "Sin información disponible"}
                                </UncontrolledTooltip>

                                <AccordionItem className="factorr" id="resta0">
                                    <div>
                                        {restan[0]?.nombre ?? ""} {/*(**)*/}<br />
                                        <img
                                            src={restan[0]?.valor > 0 ? "/check-x.png" : "/check-ok.png"}
                                            alt="estado"
                                            width="28px"
                                        />
                                        <br />

                                        <span>
                                            {restan[0]?.valor > 0 ? "NO POSEE" : "POSEE"}
                                        </span>
                                    </div>
                                </AccordionItem>

                                <UncontrolledTooltip placement="top" target="resta0">
                                    {restan[0]?.descripcion || "Sin información disponible"}
                                </UncontrolledTooltip>

                            </UncontrolledAccordion>
                        </div>

                        {/*<UncontrolledAccordion>*/}
                        {/*    <AccordionItem className="factor neutro" id="factor1">*/}
                        {/*        <AccordionHeader targetId="collapseS1">*/}
                        {/*            <span style={{ float: "left", backgroundColor: "gray" }}>*/}
                        {/*                {factores[1]?.color === 3*/}
                        {/*                    ? <> - </>*/}
                        {/*                    : redondearHaciaArriba(factores[1]?.valor ?? 0)}*/}
                        {/*            </span>*/}
                        {/*            */}{/*{factores[1]?.nombre ?? ""} (*)*/}
                        {/*        </AccordionHeader>*/}
                        {/*    </AccordionItem>*/}
                        {/*    <UncontrolledTooltip placement="left" target="factor1" >*/}
                        {/*        {factores[1]?.descripcion !== "" && factores[1]?.descripcion*/}
                        {/*            ? factores[1].descripcion*/}
                        {/*            : "Sin datos disponibles para este factor"}*/}
                        {/*    </UncontrolledTooltip>*/}

                        {/*    <AccordionItem className="factor neutro" id="factor2">*/}
                        {/*        <AccordionHeader targetId="collapseS2">*/}
                        {/*            <span style={{ float: "left", backgroundColor: "gray" }}>*/}
                        {/*                {factores[2]?.color === 3*/}
                        {/*                    ? <> - </>*/}
                        {/*                    : redondearHaciaArriba(factores[2]?.valor ?? 0)}*/}
                        {/*            </span>*/}
                        {/*            */}{/*{factores[2]?.nombre ?? ""} (*)*/}
                        {/*        </AccordionHeader>*/}
                        {/*    </AccordionItem>*/}
                        {/*    <UncontrolledTooltip placement="left" target="factor2" >*/}
                        {/*        {factores[2]?.descripcion !== "" && factores[2]?.descripcion*/}
                        {/*            ? factores[2].descripcion*/}
                        {/*            : "Sin datos disponibles para este factor"}*/}
                        {/*    </UncontrolledTooltip>*/}
                        {/*</UncontrolledAccordion>*/}

                        {/*<h6>* Estos factores no impactan en el puntaje final.</h6>*/}
                        {/*<h6>** Cuestionario de Debida Diligencia</h6>*/}

                        <div className="extra">
                            <a href="https://walink.co/013024" target="_blank" rel="noreferrer">
                                <img src="/chatbot_2.png" alt="Chatbot" />
                            </a>
                        </div>

                    </div>
                </Row>
            </Container>
        );
    }
}